module.exports = __webpack_public_path__ + "static/media/06 REGGIANA CALCIO Cim. Monumentale.4ee3b00c.svg";